import { render, staticRenderFns } from "./CivilPositionSelection.vue?vue&type=template&id=4863d4ee&"
import script from "./CivilPositionSelection.vue?vue&type=script&lang=ts&"
export * from "./CivilPositionSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports